/**
 * 模块名称: 系统公告详情
 * @author xuzhongyuan@372163.com
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import { parseSearch, judgeCryptoParamsUrl } from '@/utils'
import DetailsComp from '@/components/Details'
import urls from '@/api/urls'
import { message } from 'antd'

const Details = (props) => {
  const { history } = props
  const search = parseSearch(props.location.search)
  const [data, setData] = useState({
    id: '',
    title: '',
    crateTime: '',
    createBy: '',
    content: '',
    accessories: []
  })

  useEffect(() => {
    if (judgeCryptoParamsUrl(search)) {
      api.getSysNoticeDetails({ id: search.id }, true).then(data => {
        api.setNoticeReaded({ id: search.id })
        setData(data)
      })
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.go(-2)
      }, 1000)
    }
  }, [])

  return (
    <DetailsComp
      data={data}
      onClose={history.goBack}
      url={data.accessories.length ? `${urls.downloadNoticeAffix.url}?id=${data.id}` : null}
    />
  )
}

export default Details